import React from 'react'
import useTranslation from '../useTranslation'
import './Scoregrid.scss'

export default function Scoregrid({ scoregrid, teams, currentBattingTeam, displayInnings }) {
    const Bowler = useTranslation('Bowler')

    if (! teams || ! teams.find(i => i.name === currentBattingTeam)) {
        return (
            <div className="scoregrid">
                Waiting for teams data
            </div>
        )
    }

    const { overs } = scoregrid || {};
    const { inns1, inns2, inns3, inns4 } = overs || {};

    let tableOvers;

    switch (displayInnings) {
        case 1:
            if (inns1) {
                tableOvers = inns1;
            }
            break;
        case 2:
            if (inns2) {
                tableOvers = inns2;
            }
            break;
        case 3:
            if (inns3) {
                tableOvers = inns3;
            }
            break;
        case 4:
            if (inns4) {
                tableOvers = inns4;
            }
            break;
        default:
            return (
                <div className="scoregrid">
                    Innings yet to start
                </div>
            );
    }

    const b7present = tableOvers.find(o => o.b7 !== null)
    const b8present = tableOvers.find(o => o.b8 !== null)
    const b9present = tableOvers.find(o => o.b9 !== null)
    const b10present = tableOvers.find(o => o.b10 !== null)
    const b11present = tableOvers.find(o => o.b11 !== null)
    const b12present = tableOvers.find(o => o.b12 !== null)

    return (
        <div className="scoregrid">
            <div className="scoregrid-table">
                <div className="scoregrid-table-header">
                    <div></div>
                    <div>{Bowler}</div>
                    <div>1</div>
                    <div>2</div>
                    <div>3</div>
                    <div>4</div>
                    <div>5</div>
                    <div>6</div>
                    { b7present !== undefined && <div>7</div> }
                    { b8present !== undefined && <div>8</div> }
                    { b9present !== undefined && <div>9</div> }
                    { b10present !== undefined && <div>10</div> }
                    { b11present !== undefined && <div>11</div> }
                    { b12present !== undefined && <div>12</div> }
                    <div>R</div>
                    <div>T</div>
                    <div>W</div>
                </div>
                {tableOvers.map(({ ov, bowler, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, runs, total, wkts }) => {

                    // Really ugly but this replaces value 88 (ball in progress) returned in the data
                    // with ...
                    if (b1 === '88') {
                        b1 = '...'
                    }
                    if (b2 === '88') {
                        b2 = '...'
                    }
                    if (b3 === '88') {
                        b3 = '...'
                    }
                    if (b4 === '88') {
                        b4 = '...'
                    }
                    if (b5 === '88') {
                        b5 = '...'
                    }
                    if (b6 === '88') {
                        b6 = '...'
                    }
                    if (b7 === '88') {
                        b7 = '...'
                    }
                    if (b8 === '88') {
                        b8 = '...'
                    }
                    if (b9 === '88') {
                        b9 = '...'
                    }
                    if (b10 === '88') {
                        b10 = '...'
                    }
                    if (b11 === '88') {
                        b11 = '...'
                    }
                    if (b12 === '88') {
                        b12 = '...'
                    }
                    
                    return (
                        <div className="scoregrid-table-row" key={ov}>
                            <div>{ov}</div>
                            <div>{bowler}</div> 
                            <div>{b1}</div>
                            <div>{b2}</div>
                            <div>{b3}</div>
                            <div>{b4}</div>
                            <div>{b5}</div>
                            <div>{b6}</div>
                            { b7present !== undefined && <div>{b7}</div> }
                            { b8present !== undefined && <div>{b8}</div> }
                            { b9present !== undefined && <div>{b9}</div> }
                            { b10present !== undefined && <div>{b10}</div> }
                            { b11present !== undefined && <div>{b11}</div> }
                            { b12present !== undefined && <div>{b12}</div> }
                            <div>{runs}</div>
                            <div>{total}</div>
                            <div>{wkts}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
